import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const AsyncCsmRequestDetails = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: 'async-csm-request-details' */ './csm-request-details')),
});
